import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchApi } from '../../Helpers/Functions';
import { addNewTask } from '../../store/SequenceObject';
import { setModalOpen } from '../../store/Utilities';
import { pathDelmiter, URLs } from '../../Constants/Consts';
import { DDCheckList } from '../../types/DataDD/DataDD';
import type { FormVariant, TAddTaskAPIResponse } from './types';

export function useAddChecklistTaskSubmit(
    variant: FormVariant,
    firstTask: DDCheckList,
    path: string,
    reset: () => void,
) {
    const dispatch = useDispatch();

    return useCallback(
        async (data: unknown) => {
            const uuid = crypto.randomUUID().toUpperCase() as `${string}-${string}-${string}-${string}-${string}`;
            const newTaskBody = variant.getPayload(data, firstTask, uuid);

            try {
                if (navigator.onLine) {
                    const response = await fetchApi(URLs.postDDADHOC(), {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(newTaskBody),
                    });
                    const json = (await response.json()) as TAddTaskAPIResponse;
                    if (!response.ok || !json.success) {
                        throw new Error(json.message || 'Failed to add task');
                    }
                }

                dispatch(addNewTask({ path: `${path}${pathDelmiter}${uuid}`, newTask: newTaskBody }));
                dispatch(setModalOpen(false));
                toast.success('New task added successfully.');
                reset();
            } catch (error) {
                console.error('Error adding task:', error);
                toast.error(error instanceof Error ? error.message : 'An error occurred while adding the task.');
            }
        },
        [variant, firstTask, path, dispatch, reset],
    );
}
